import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './20-ai-limitations.mp3';

const autoNextDuration = 111000;
const transcript = `
  AI is krachtig, maar zeker niet perfect. Er zijn nog steeds beperkingen en uitdagingen die belangrijk zijn om te 
  begrijpen.  

  Een van de grootste valkuilen is dat AI verkeerde antwoorden kan hallucineren zonder zelftwijfel. Het antwoordt met 
  volle overtuiging – en dat kan heel misleidend zijn.  

  Daarnaast is creativiteit beperkt zonder menselijke sturing. Het heeft de neiging om in het meest voor de hand 
  liggende te vervallen. Jullie creativiteit kan dat verhelpen.  

  Ook kan AI vastlopen op schijnbaar eenvoudige menselijke taken. Dingen die voor mensen vanzelfsprekend zijn, kunnen 
  soms voor een AI verrassend lastig zijn. Dit kan voor jullie mensen erg frustrerend zijn.  

  Een andere uitdaging is bias – vooroordelen die in de trainingsdata zitten. Wat op het internet te vinden is, wordt 
  ook opgenomen in AI-systemen. Het is aan jullie om daarvoor te waken.  

  Weten jullie wat er momenteel in Amerika speelt? Het land waar bijna al onze AI-technologie vandaan komt? Er is geen 
  garantie dat deze modellen in de toekomst met onze normen en waarden in lijn zullen liggen.  

  Ditzelfde geldt uiteraard voor modellen uit China, die sterk gekleurd en gecensureerd zijn door de Chinese overheid.  

  Onthoud dat hoewel de slimste AI-systemen qua IQ uitblinken boven mensen, ze niet gehard zijn door miljoenen jaren 
  evolutie. Dus hoewel ze briljant lijken op sommige vlakken, hebben ze bij lange na niet het aanpassingsvermogen van 
  mensen en vooralsnog een zeer, zeer beperkt begrip van de wereld. Begrijp immers dat ik niet kan zien zoals jullie.
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="bottom-right"
      networkBackground="full"
      autoNext={autoNextDuration}
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1>
          Beperkingen van <u>AI</u>
        </h1>
        <div className="text-left space-y-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p>Belangrijke uitdagingen om te begrijpen</p>
          </WebContent>
          <ul className="list-disc list-inside space-y-2">
            <WebContent
              animation={{
                type: 'fade',
                delay: 11000,
                duration: 800,
              }}
            >
              <li>Hallucinaties zonder zelftwijfel</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 22000,
                duration: 800,
              }}
            >
              <li>Beperkte creativiteit zonder menselijke sturing</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 32000,
                duration: 800,
              }}
            >
              <li>Moeite met 'eenvoudige' menselijke taken</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 47000,
                duration: 800,
              }}
            >
              <li>Bias en vooroordelen uit trainingsdata</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 63000,
                duration: 800,
              }}
            >
              <li>Afhankelijkheid van buitenlandse technologie</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 70000,
                duration: 800,
              }}
            >
              <li>Normen en waarden niet gegarandeerd</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 83000,
                duration: 800,
              }}
            >
              <li>Beperkt begrip van de fysieke wereld</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 90000,
                duration: 800,
              }}
            >
              <li>Geen evolutionair aanpassingsvermogen</li>
            </WebContent>
          </ul>
        </div>
      </div>
    </Slide>
  );
};
